export const ApiConfig = {
  apiKey: "AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg",
  authDomain: "aazma.ir",
  baseUrl: "https://aazma.ir/api/v1/",
  //baseUrl: 'http://localhost:3030/api/v1',
  loginURL: "user/login",
  otploginURL: "user/otp/login",
  logoutURL: "user/logout",
};
